
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"180","height":"136","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1","width":"178","height":"134","rx":"13","fill":"#F4F6FA"}}),_c('path',{attrs:{"opacity":".4","fill":"#9AA5BB","fill-opacity":".5","d":"M30 30h27v6H30zM30 83h120v6H30zM87 30h63v6H87zM30 40h120v6H30zM30 93h120v6H30zM30 50h120v6H30zM30 103h75v6H30zM135 103h15v6h-15zM30 60h52v6H30zM30 113h52v6H30z"}}),_c('rect',{attrs:{"opacity":".6","x":"60","y":"29","width":"24","height":"8","rx":"4","fill":"#F39"}}),_c('rect',{attrs:{"opacity":".6","x":"108","y":"102","width":"24","height":"8","rx":"4","fill":"#F39"}}),_c('path',{attrs:{"d":"M29 21l4.267-10H45l-4.267 10H29z","fill":"#9AA5BB","fill-opacity":".25"}})])
          )
        }
      }
    